import cfPricingData from '../../../data/pricing/cloudflare-pricing.json';
import geminiPricingData from '../../../data/pricing/gemini-pricing.json';
import openrouterPricingData from '../../../data/pricing/openrouter-pricing.json';

type PricingEntry = { input: number; output: number };

export const CF_PRICING = cfPricingData as unknown as Record<string, PricingEntry>;
export const GEMINI_PRICING = geminiPricingData as unknown as Record<string, PricingEntry>;
export const OPENROUTER_PRICING = openrouterPricingData as unknown as Record<string, PricingEntry>;

/** Format a CF model's pricing as a human-readable string. */
export function formatCFPricing(model: string, info?: string): string {
  const p = CF_PRICING[model];
  if (!p) return 'Cloudflare Workers AI pricing per token';
  const base = `$${p.input.toFixed(3)}/$${p.output.toFixed(3)} per M tokens`;
  return info ? `${base} · ${info}` : base;
}

/** Format a Gemini model's pricing prepended to its info string. */
export function formatGeminiPricing(model: string, info: string): string {
  const p = GEMINI_PRICING[model];
  if (!p) return info;
  return `$${p.input.toFixed(2)}/$${p.output.toFixed(2)} per M tokens · ${info}`;
}

/** Format an OpenRouter model's pricing prepended to its info string. */
export function formatOpenRouterPricing(model: string, info: string): string {
  const p = OPENROUTER_PRICING[model];
  if (!p) return info;
  return `$${p.input.toFixed(2)}/$${p.output.toFixed(2)} per M tokens · ${info}`;
}
